import api from "./api";

// Capa de servicios API del dominio "performance" (métricas VPS/rendimiento) (FSD / capa API transversal).
export const getPerformanceMetrics = () => api.get("/performance/metrics");
